import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import BulkIcon from "@mui/icons-material/Email";
import NewCommunicationIcon from "@mui/icons-material/Send";

import { createNewCommunicationRequest } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import { deepCopyObject } from "../../utils/helpers";
import AlertDialog from "../dialogs/alertDialog";
import CommunicationRequestBulkDialog from "../dialogs/communicationRequestBulkDialog";
import CommunicationRequestDialog from "../dialogs/communicationRequestDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import SurveyCommunicationRequests from "../ui/surveyCommunicationRequests";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent.js";
import WidgetTitle from "../ui/widgetTitle";

const AdminCommunications = props => {
  const {
    communicationTemplateODMs,
    inviteODMs,
    loadCommunicationRequestsRequest,
    communicationRequestODMs,
    communicationRequestPageLoading,
    communicationRequestPagination,
  } = props;

  const [confirmSend, setConfirmSend] = useState(null);

  useEffect(() => {
    if (communicationRequestODMs != null) {
      setRows(communicationRequestODMs);
    }
  }, [communicationRequestODMs]);
  // const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);

  const [selectedCommunicationRequest, setSelectedCommunicationRequest] = useState(null);
  const [bulkCommunicationRequest, setBulkCommunicationRequest] = useState(null);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (communicationRequestPagination != null) {
      setTitleText(
        `${communicationRequestPagination.totalItems} Request${
          communicationRequestPagination.totalItems === 1 ? "" : "s"
        }`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [communicationRequestPagination]);

  return (
    <Widget>
      <WidgetTitle
        title={"Communications"}
        text={titleText}
        loading={communicationTemplateODMs == null}
      >
        <OmniResponsiveButton
          icon={<BulkIcon />}
          tooltipTitle="Send Communications on behalf of this Organization"
          buttonText="Bulk"
          onClick={() => {
            setBulkCommunicationRequest(true);
          }}
        />
        <OmniResponsiveButton
          icon={<NewCommunicationIcon />}
          tooltipTitle="Send Communications on behalf of this Organization"
          buttonText="Single"
          onClick={() => {
            let theRep = createNewCommunicationRequest();
            setSelectedCommunicationRequest(theRep);
          }}
        />
      </WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyCommunicationRequests
            communicationRequestODMs={rows}
            onEditCommunicationRequest={setSelectedCommunicationRequest}
            onRequestNewPage={loadCommunicationRequestsRequest}
            isLoading={communicationRequestPageLoading}
            communicationRequestPagination={communicationRequestPagination}
            onSendHandler={setConfirmSend}
          />
        </WidgetSurveyContent>
      )}

      {selectedCommunicationRequest && (
        <CommunicationRequestDialog
          inviteODMs={inviteODMs}
          open={selectedCommunicationRequest != null}
          emailTemplates={communicationTemplateODMs}
          dialogTitle={`${
            selectedCommunicationRequest._id == null
              ? "Create Communication Request"
              : "Communication Request"
          }`}
          omniODM={deepCopyObject(selectedCommunicationRequest)} //this widget just creates new
          onDelete={id => {
            props.deleteCommunicationRequestRequest(id);
            setSelectedCommunicationRequest(null);
          }}
          onAccept={communicationRequest => {
            communicationRequest.omniData["organizationId"] = props.organizationODM._id;
            props.updateCommunicationRequestRequest(communicationRequest);
            setSelectedCommunicationRequest(null);
          }}
          onClose={() => {
            setSelectedCommunicationRequest(null);
          }}
          onResend={() => {
            setConfirmSend(selectedCommunicationRequest);
          }}
        />
      )}
      {bulkCommunicationRequest && (
        <CommunicationRequestBulkDialog
          inviteODMs={inviteODMs}
          open={bulkCommunicationRequest != null}
          emailTemplates={communicationTemplateODMs}
          dialogTitle={"Bulk Campaign Communication Requests"}
          // omniODM={deepCopyObject(selectedCommunicationRequest)} //this widget just creates new
          // onDelete={id => {
          //   props.deleteCommunicationReqsuestRequest(id);
          //   setSelectedCommunicationRequest(null);
          // }}
          onAccept={communicationRequest => {
            //todo
            setBulkCommunicationRequest(false);
          }}
          onClose={() => {
            setBulkCommunicationRequest(false);
          }}
          // onResend={() => {
          //   setConfirmSend(selectedCommunicationRequest);
          // }}
        />
      )}

      {confirmSend && (
        <AlertDialog
          open={confirmSend}
          dialogTitle={`Confirm`}
          dialogMessage={"Send this Communication Request to our Email Service?"}
          onAccept={() => {
            props.prosecuteCampaignRequest(confirmSend);
            setConfirmSend(null);
          }}
          onClose={() => {
            setConfirmSend(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  communicationTemplateODMs: state.adminSession.communicationTemplateODMs,
  communicationRequestODMs: state.adminSession.communicationRequestODMs,
  communicationRequestPageLoading: state.adminSession.communicationRequestPageLoading,
  communicationRequestPagination: state.adminSession.communicationRequestPagination,

  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  prosecuteCampaignRequest: AdminSessionActions.prosecuteCampaignRequest,

  loadCommunicationRequestsRequest: AdminSessionActions.loadCommunicationRequestsRequest,
  updateCommunicationRequestRequest: AdminSessionActions.updateCommunicationRequestRequest,
  deleteCommunicationRequestRequest: AdminSessionActions.deleteCommunicationRequestRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCommunications);
